import { createFileRoute } from "@tanstack/react-router";
import {ShiftsListPage} from "../../../components/Shifts/ShiftsPage.tsx";


export const Route = createFileRoute("/_layout/shift-entries-list/shift-entries")({
  component: ShiftsListPage,
});


